var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserCircle = function SvgUserCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3.5a8.5 8.5 0 0 0-6.38 14.116 5.25 5.25 0 0 1 5.105-4.02h2.55a5.25 5.25 0 0 1 5.105 4.02A8.5 8.5 0 0 0 12 3.5m5.025 15.357v-.011a3.75 3.75 0 0 0-3.75-3.75h-2.55a3.75 3.75 0 0 0-3.75 3.75v.01A8.46 8.46 0 0 0 12 20.5c1.88 0 3.617-.61 5.025-1.643M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-4.75a2.018 2.018 0 1 0 0 4.036 2.018 2.018 0 0 0 0-4.036M8.48 9.268a3.518 3.518 0 1 1 7.036 0 3.518 3.518 0 0 1-7.036 0",
    clipRule: "evenodd"
  })));
};
export default SvgUserCircle;